export default __webpack_public_path__ + "static/media/roboto-v20-cyrillic_latin-500.9024e4c1.svg";